
function APIError() {
  return (
    <div>
      <h1>API Error</h1>
      <p>There was an error with the API</p>
    </div>
  );
}

export default APIError;